import Swal from 'sweetalert2';

// Common SweetAlert2 configurations
export const SweetAlert = {
    // Confirmation dialog with custom options
    confirm: ({
        title = 'Are you sure?',
        text = '',
        icon = 'warning',
        confirmButtonText = 'Yes',
        cancelButtonText = 'Cancel',
        confirmButtonColor = '#d33',
        cancelButtonColor = '#3085d6',
        showCancelButton = true,
        ...customOptions
    } = {}) => {
        return Swal.fire({
            title,
            text,
            icon,
            showCancelButton,
            confirmButtonColor,
            cancelButtonColor,
            confirmButtonText,
            cancelButtonText,
            ...customOptions
        });
    },

    // Delete confirmation dialog
    deleteConfirm: ({
        itemName = 'item',
        itemType = 'item',
        customText = null,
        onConfirm = null,
        ...customOptions
    } = {}) => {
        const text = customText || `You want to delete the '${itemName}' ${itemType}? You won't be able to revert this!`;
        
        return SweetAlert.confirm({
            title: 'Are you sure?',
            text,
            icon: 'warning',
            confirmButtonText: 'Yes, delete it!',
            confirmButtonColor: '#d33',
            ...customOptions
        }).then((result) => {
            if (result.isConfirmed && onConfirm) {
                onConfirm();
            }
            return result;
        });
    },

    // Status toggle confirmation dialog
    statusToggle: ({
        itemName = 'item',
        itemType = 'item',
        newStatus = true,
        customText = null,
        onConfirm = null,
        ...customOptions
    } = {}) => {
        const actionText = newStatus ? 'enable' : 'disable';
        const text = customText || `You want to ${actionText} the '${itemName}' ${itemType}?`;
        
        return SweetAlert.confirm({
            title: 'Are you sure?',
            text,
            icon: 'warning',
            confirmButtonText: `Yes, ${actionText} it!`,
            confirmButtonColor: '#d33',
            ...customOptions
        }).then((result) => {
            if (result.isConfirmed && onConfirm) {
                onConfirm();
            }
            return result;
        });
    },

    // Success message
    success: ({
        title = 'Success!',
        text = 'Operation completed successfully.',
        timer = 3000,
        showConfirmButton = false,
        ...customOptions
    } = {}) => {
        return Swal.fire({
            title,
            text,
            icon: 'success',
            timer,
            showConfirmButton,
            ...customOptions
        });
    },

    // Error message
    error: ({
        title = 'Error!',
        text = 'Something went wrong.',
        ...customOptions
    } = {}) => {
        return Swal.fire({
            title,
            text,
            icon: 'error',
            confirmButtonText: 'OK',
            ...customOptions
        });
    },

    // Info message
    info: ({
        title = 'Information',
        text = '',
        ...customOptions
    } = {}) => {
        return Swal.fire({
            title,
            text,
            icon: 'info',
            confirmButtonText: 'OK',
            ...customOptions
        });
    },

    // Warning message
    warning: ({
        title = 'Warning!',
        text = '',
        ...customOptions
    } = {}) => {
        return Swal.fire({
            title,
            text,
            icon: 'warning',
            confirmButtonText: 'OK',
            ...customOptions
        });
    },

    // Loading/Progress dialog
    loading: ({
        title = 'Loading...',
        text = 'Please wait',
        allowOutsideClick = false,
        allowEscapeKey = false,
        showConfirmButton = false,
        ...customOptions
    } = {}) => {
        return Swal.fire({
            title,
            text,
            allowOutsideClick,
            allowEscapeKey,
            showConfirmButton,
            didOpen: () => {
                Swal.showLoading();
            },
            ...customOptions
        });
    },

    // Close any open Swal dialog
    close: () => {
        Swal.close();
    }
};

export default SweetAlert;